import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  Renderer2,
  ElementRef,
  Output,
  HostListener
} from '@angular/core'
import {
  faFileDownload,
  IconDefinition
} from '@fortawesome/free-solid-svg-icons'
import { PDFDocumentProxy } from 'ng2-pdf-viewer'
import { FileSnapshot } from '../../models/file-snapshot'
import { SignatoryService } from '../../services/signatory-service'
import { EventEmitter } from 'protractor'

@Component({
  selector: 'psrs-inline-pdf',
  templateUrl: './inline-pdf.component.html',
  styleUrls: ['./inline-pdf.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InlinePdfComponent implements OnInit {
  faFileDownload: IconDefinition = faFileDownload
  collectionSize: number = 0
  page: number = 1
  fileUri: string

  @Input() PdfFile: FileSnapshot

  @Input() pdfUrl: string

  constructor (
    private signatoryService: SignatoryService,
    private renderer: Renderer2,
    private el: ElementRef
  ) {}

  pdfWidth: number
  zoomScale: number = 1.0

  @HostListener('window:resize', ['$event'])
  onResize (event: Event): void {
    this.updateWidth()
    this.updateZoom()
  }

  private updateWidth (): void {
    this.pdfWidth = window.innerWidth - (window.innerWidth * 10) / 100
  }

  private updateZoom (): void {
    if (window.innerWidth <= 768) {
      this.zoomScale = this.pdfWidth / 800
    } else {
      this.zoomScale = this.pdfWidth / 1000
    }
  }

  ngOnInit (): void {
    this.updateWidth()
    this.updateZoom()

    this.fileUri = this.signatoryService.getUrl(this.PdfFile)
  }

  pageChanged (pageNo: number): void {
    this.page = pageNo
  }

  afterLoadComplete (pdfDoc: PDFDocumentProxy): void {
    this.collectionSize = pdfDoc.numPages * 10
  }
}
